// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Y4t19","clinicsSelect":"styles_clinicsSelect__AeWEN"};